var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagNetherlands(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagNetherlands_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagNetherlands_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagNetherlands_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagNetherlands_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagNetherlands_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4BA0D9",
    d: "M-12 44.116h70.482V30.412H-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M-12 30.412h70.482V16.707H-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC1C37",
    d: "M-12 16.707h70.482V2.998H-12z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iZmU3b25mdWZ0YSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJmaXpqdHcxaWNiIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2ZlN29uZnVmdGEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiNmZTdvbmZ1ZnRhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjZml6anR3MWljYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzRCQTBEOSIgZD0iTTAgNDEuMTE2TDcwLjQ4MiA0MS4xMTYgNzAuNDgyIDI3LjQxMiAwIDI3LjQxMnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMiAzKSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGNEY0RjQiIGQ9Ik0wIDI3LjQxMkw3MC40ODIgMjcuNDEyIDcwLjQ4MiAxMy43MDcgMCAxMy43MDd6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIgMykiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjREMxQzM3IiBkPSJNMCAxMy43MDdMNzAuNDgyIDEzLjcwNyA3MC40ODIgLTAuMDAyIDAgLTAuMDAyeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyIDMpIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgFlagNetherlands as ReactComponent };